module.exports = "<aside class=\"aside-menu\">\n</aside>\n"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/core/components/layout/sidebar-left/sidebar-left.component.html
// module id = ../../../../../src/app/core/components/layout/sidebar-left/sidebar-left.component.html
// module chunks = main